import { generateGuid } from '@bingads-webui-universal/primitive-utilities';

export const generateId = prefix => `${prefix}-${generateGuid().substr(0, 8)}`;

export const generateSectionWithComponent = ({
  componentType,
  sectionIndex,
}) => {
  const sectionId = generateId('sec');
  const groupId = generateId('grp');
  const componentId = generateId('cmp');

  return [
    {
      type: 'section',
      id: sectionId,
      order: sectionIndex,
    }, {
      type: 'group',
      id: groupId,
      parentId: sectionId,
      order: 0,
    }, {
      type: componentType,
      id: componentId,
      parentId: groupId,
      order: 0,
    },
  ];
};
